import "./TopSelling.css";
const TopSelling = () => {
 return (
  <div className="top-selling">
   <p className="title">Top Selling Products</p>
   <div className="card-container">
    <table>
     <thead>
      <tr>
       <th>Product name</th>
       <th>Amount</th>
       <th>No. of Purchases</th>
      </tr>
     </thead>
     <tbody>
      <tr>
       <td>Mind games of a br...</td>
       <td>N120,450</td>
       <td>150</td>
      </tr>

      <tr>
       <td>Mind games of a br...</td>
       <td>N120,450</td>
       <td>150</td>
      </tr>

      <tr>
       <td>Mind games of a br...</td>
       <td>N120,450</td>
       <td>150</td>
      </tr>

      <tr>
       <td>Mind games of a br...</td>
       <td>N120,450</td>
       <td>150</td>
      </tr>

      <tr>
       <td>Mind games of a br...</td>
       <td>N120,450</td>
       <td>150</td>
      </tr>
     </tbody>
    </table>
   </div>
  </div>
 );
};

export default TopSelling;
